import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import "./AddBrandDocumentModal.scss";
import CommonInputField from "../../BrandsPartnerComponents/common_input_field";
import { UploadBrandDocument } from "../../../../API/endpoints/Brands";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

function AddBrandDocumentModal(props: {
  onCancel: () => void;
  isModalOpen: boolean | undefined;
  brand_id: string;
  setNotification: React.Dispatch<
    React.SetStateAction<{ type: string; msg: string }>
  >;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [data, setData] = useState<any>(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const [documentName, setDocumentName] = useState("");
  const [documentDescription, setDocumentDescription] = useState("");
  const [fileType, setFileType] = useState("");
  const myRefname: React.MutableRefObject<any> = useRef(null);
  const handleClick = () => {
    myRefname.current.click();
  };

  const { handleSubmit } = useForm({
    defaultValues: {
      document_name: "",
      file: undefined,
    },
  });

  const handleClose = () => {
    props.onCancel();
    setData(undefined);
  };

  const onFormSubmit = async () => {
    try {
      const formSubmitData = new FormData();
      formSubmitData.append("file", data);
      formSubmitData.append("file_name", documentName);
      formSubmitData.append("description", documentDescription);
      formSubmitData.append("service", "1");
      formSubmitData.append("brand_id", props.brand_id);
      formSubmitData.append("field", fileType);

      await UploadBrandDocument(formSubmitData);
      props.setNotification({
        type: "success",
        msg: "Document Uploaded",
      });
      props.setReload((current) => !current);
      handleClose();
    } catch (err) {
      console.log("err");
    }
  };

  const uploadHandler = (event: any) => {
    const file = event.target.files[0];
    if (!file) return;
    file.isUploading = true;
    setData(file);
    if (file.type !== "application/pdf") {
      setErrorMessage("The file is not a PDF");
    }
  };

  const deleteFile = () => {
    setData(undefined);
    setErrorMessage("");
  };

  return (
    <Modal show={props.isModalOpen} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Document</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={handleSubmit((data) => {
            onFormSubmit();
          })}
        >
          <Col sm={12} lg={12} xl={12} className="p-03">
            <Form.Group className="form-group" controlId="document_name">
              <Form.Label>Document Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="File Name"
                onChange={(e) => setDocumentName(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col sm={12} lg={12} xl={12} className="p-03">
            <Form.Group controlId="" className="form-group !mb-[0]">
              <Form.Label>Document Description</Form.Label>
              <Form.Control
                style={{
                  textAlign: "left",
                  color: "#475467",
                }}
                as="textarea"
                rows={3}
                placeholder="Sample text"
                onChange={(e) => setDocumentDescription(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col sm={12} lg={12} xl={12} className="p-03">
            <FormControl size="small" className="w-[100%] !mb-[1rem] ">
              <label>File type</label>
              <Select
                label="fileType"
                onChange={(e: any) => setFileType(e?.target?.value)}
              >
                <MenuItem value="brand_asset" key={1}>
                  Brand Assets
                </MenuItem>
                <MenuItem value="business_intelligence" key={2}>
                  Business Intelligence
                </MenuItem>
                <MenuItem value="market_intelligence" key={3}>
                  Market Intelligence
                </MenuItem>
              </Select>
            </FormControl>
          </Col>
          <Row>
            <Col>
              <div className="file-card" onClick={handleClick}>
                <div className="file-inputs">
                  <input
                    type="file"
                    ref={myRefname}
                    onChange={uploadHandler}
                    accept="image/png,.pdf"
                  />

                  <div className="file-upload-img flex justify-center">
                    <img
                      className="headerPlusIcon"
                      src="../svgs/cloud-arrow-up-fill.svg"
                      alt=""
                    />
                  </div>
                </div>

                <>
                  <p className="main">Click to upload</p>
                  <p className="info">or drag and drop</p>
                  <p className="info">Supported file type: PDF</p>
                </>
              </div>
            </Col>
          </Row>
          <Row>
            <ul className="file-list">
              {data && (
                <>
                  <li className="file-item" key={data.name}>
                    <p>{data.name}</p>
                    <div className="actions">
                      <img
                        src="../svgs/trash.svg"
                        alt=""
                        onClick={() => {
                          deleteFile();
                        }}
                      />
                    </div>
                  </li>
                  <Form.Text muted>
                    <span>
                      {errorMessage && (
                        <p className="error-form">{errorMessage}</p>
                      )}
                    </span>
                  </Form.Text>
                </>
              )}
            </ul>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer className="footer">
        <Button
          className="primaryButton"
          variant="secondary"
          onClick={handleClose}
        >
          Close
        </Button>
        <Button
          className="!bg-[#0152FB]"
          variant="primary"
          type="submit"
          onClick={handleSubmit((data) => {
            onFormSubmit();
          })}
          disabled={
            !(
              data &&
              documentName &&
              documentDescription &&
              fileType &&
              !errorMessage
            )
          }
        >
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddBrandDocumentModal;
